// extracted by mini-css-extract-plugin
export default {"home_slider_section_wrapper":"Home_home_slider_section_wrapper__yB95q"};